import api, { apiNoLoading, IDataRequest, IDataResponse, IHttpClient, STATUS_CODE } from "src/framework/providers/api";

class AdminStore {
    constructor(private provider: IHttpClient) { }


    async getListaSistemas(): Promise<any> {
        const request: IDataRequest = {
            url: "/sistemas",
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getGruposAcesso({ currentId, sistema, herdados = false }: { currentId?: string, sistema?: string, herdados?: boolean }): Promise<any> {

        let filter: string = "";

        if (currentId) {
            filter += `&id_not_in=${currentId}`
        }

        if (sistema) {
            filter += `&sistema_id=${sistema}`;
        }

        let includes = "&includes=sistema"
        if (herdados) {
            includes += ",herdados,grupo_acesso_herdado"
        }


        const request: IDataRequest = {
            url: `/grupos_acesso/cache?orderby=sistema_id${includes}${filter}`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data;
        }

        return [];
    }

    async getFuncionalidadeGrupo(idsGrupoAcesso: number[]): Promise<any> {

        let filter = idsGrupoAcesso.length > 0 ? `""&grupo_acesso_id_in=${idsGrupoAcesso.join(",")}` : "";

        const request: IDataRequest = {
            url: `/grupos_acesso/funcionalidades?includes=sistema${filter}`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data;
        }

        return [];
    }

    async getFuncionalidades(sistemaId: number): Promise<any> {

        let filter = `&sistema_id=${sistemaId}`;

        const request: IDataRequest = {
            url: `/funcionalidades?orderby=grupo,operacao,funcionalidade_id,menu_id-desc${filter}`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data;
        }

        return [];
    }

    async getMenuList(sistemaId: number): Promise<any> {

        let filter = `&sistema_id=${sistemaId}`;

        const request: IDataRequest = {
            url: `/menu?orderby=sistema_id,menu_id,ordem${filter}`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data;
        }

        return [];
    }

    
    async getProjetos(page: number | undefined, pageSize: number | undefined, titulo: string, codigo_projeto: string, id_projeto: number | null, numero_pedido: string | number,  nome_cliente: string,  cpf_cliente: string, email_cliente: string, n_nota_fiscal: string, criado_por: string, revenda_id: any, distribuidor_id: any, etapa_venda: { text: string; value: string; }[], projeto_expirado: any, projeto_kits: any, situacao: null | { text: string; value: string; }, segmentos: null | { text: string; value: string; }, origem: null | { text: string; value: string; }, migrado: null | { text: string; value: string; }, finame: null | { text: string; value: string; }, tipo: { text: string; value: string; }[], noLoading?: boolean): Promise<any> {
        let filter: string = "";
        let aEtapasFilter = [];

        if (id_projeto){
            filter += `&id=${id_projeto}`
        } else {
            if(etapa_venda.length){
                for (let i=0;i<etapa_venda.length;i++){
                    aEtapasFilter.push(etapa_venda[i].value)
                }
                filter += `&status_projeto_in=${aEtapasFilter.join(',')}`;
            }
            if(situacao){
                filter += `&status_projeto_pagamento_in=${situacao.value}`;
            }
    
            if(tipo.length){
                for (let i=0;i<tipo.length;i++){
                    aEtapasFilter.push(tipo[i].value)
                }
                filter += `&tipo_in=${aEtapasFilter.join(',')}`;
            }
            
            if (codigo_projeto) {
                filter += `&codigo_venda_like=${codigo_projeto.trim()}`
            }
            if (titulo) {
                filter += `&titulo_like=${titulo}`
            }
            if (segmentos) {
                filter += `&segmento_in=${segmentos.value}`
            }
            if (origem) {
                filter += `&origem=${origem.value}`
            }
            if (migrado) {
                filter += `&migrado=${migrado.value}`
            }
            if (projeto_kits) {
                if(projeto_kits.value === 'kit'){
                    filter += `&tipo=kit`
                }
                if(projeto_kits.value === 'n_kit'){
                    filter += `&tipo_not_in=kit`
                }
            }
            if (projeto_expirado) {
                if(projeto_expirado.value === 'expirado'){
                    filter += `&situacao=expirado`
                }
                if(projeto_expirado.value === 'n_expirado'){
                    filter += `&situacao_not_in=expirado`
                }
            }
            if (finame){
                if(finame.value === 'finame'){
                    filter += `&finame=s_finame`;
                }else if(finame.value === 'n_finame'){
                    filter += `&finame=n_finame`;
                }
            }
            if (email_cliente) {
                filter += `&email_proposta_like=${email_cliente}`
            }
            if (cpf_cliente) {
                let _cpf_cliente = cpf_cliente.replace(/[^a-zA-Z0-9]/g,"");
                filter += `&cpf_cnpj_like=${_cpf_cliente}`;
            }
            if (nome_cliente) {
                filter += `&cliente_proposta_like=${nome_cliente}`
            }
            if (criado_por) {
                filter += `&nome_criado_por_like=${criado_por}`
            }/*
            if (situacao) {
                filter += `&situacao_pagamento=${situacao.value}`
            }*/
            if (revenda_id){
                filter += `&revenda_id=${revenda_id?.id}`
            }
            if (distribuidor_id){
                filter += `&distribuidor_id=${distribuidor_id?.id}`
            }
            if (numero_pedido){
                filter += `&pedido_erp=${numero_pedido}`;
            }
            if (n_nota_fiscal){
                filter += `&n_nota_fiscal=${n_nota_fiscal}`;
            }
            if (String(page)) {
                filter += `&page=${page}`
            }
            if (pageSize) {
                filter += `&limit=${pageSize}`
            }
        }

        const request: IDataRequest = {
            url: 
                id_projeto 
                ? `projetos/listar?includes=documentos_servico,vendedor_interno,timelines,revisoes,uploads,cidade,revenda,revenda.classificacao,distribuidor,analista,ev,supervisor,assistente,usuario,criador,classificacao_revenda,componentes,clonado,clonado.origem,componentes_modificados&orderby=data_criacao-desc${filter}`
                : `projetos/listar?includes=documentos_servico,vendedor_interno,timelines,revisoes,uploads,revenda,revenda.classificacao,distribuidor,ev,criador,classificacao_revenda,componentes,clonado,clonado.origem&orderby=data_criacao-desc${filter}`
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }
        
        return [];
    }


    async getModulos(componente_id: number, noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/componentes/modulos_inversores/${componente_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getProjeto(projeto_id: number, noLoading?: boolean): Promise<any> {

        const request: IDataRequest = {
            //url: `/projetos/${projeto_id}/?includes=confirmado_por,endereco,endereco.cidade,visita_tecnica_texto,pedidos,componentes,componentes.componente,uploads,cidade,revenda,revenda.cidade,distribuidor,distribuidor.cidade,analista,ev,supervisor,assistente,usuario,criador&origem=V2`,
            url: `/projetos/consultar/detalhe/${projeto_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async buscarProjeto(projeto_id: number, noLoading?: boolean): Promise<any> {
        
        const request: IDataRequest = {
            url: `/projetos/buscar/${projeto_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getProjetoTrocasPendentes(projeto_id: number, noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/projetos/consultar_trocas_pendentes/${projeto_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK && response?.data?.[0]) {
            return response.data[0];
        }

        return null;
    }

    async getTextos(projeto_ids: any): Promise<any> {
        const request: IDataRequest = {
            url: `/cadastros/visita_tecnica/textos`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getPedidos(projeto_ids: any, noLoading?: boolean): Promise<any> {

        const request: IDataRequest = {
            url: `/vendas/pedidos?projeto_id_in=${projeto_ids}&includes=notificacoes,forma_pagamento,rastreamentos,pagamentos,pagamentos.forma_pagamento,notas_fiscais,notas_fiscais.itens,notas_fiscais.uploads,endereco,endereco.cidade,cliente,pagamentos_historico,nota_fiscal_conta_ordem&orderBy_desc=pagamentos_historico.data_atualizacao_pagamento`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }


    async getComponentes(categorias: number[], page: number, pageSize: number, filterComplement: string, noLoading?: boolean): Promise<any> {
        let filter: string = "";
        if (categorias?.length) {
            filter = `&categoria_componentes_id_in=${categorias}`;
        }

        if (filterComplement) {
            filter += `&${filterComplement}`;
        }

        if (String(page)) {
            filter += `&page=${page}`
        }
    
        if (pageSize) {
            filter += `&limit=${pageSize}`
        }
    
        const request: IDataRequest = {
            url: `/estoque/componentes?includes=uploads,atributos,modulos${filter}`,
        }        
        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

        
    async getPedidoHistorico(pedido_id: any, noLoading?: boolean): Promise<any> {

        const request: IDataRequest = {
            url: `/vendas/pedidos/historico/${pedido_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getModulosInversores(id: number, modulo_id: number, noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/modulos_inversores?inversor_id=${id}&modulo_id=${modulo_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getModulosInversoresCalculados(inversores: any[], modulo_id: number, quantidadeModulos: number): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/modulos_inversores/modulos/calculados`,
            data: { 'inversores': inversores, 'modulo_id': modulo_id, 'quantidade_modulos': quantidadeModulos }
        }

        const response: IDataResponse = await this.provider.post(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }
    
    async getPagamentoHistorico(pagamento_id: any): Promise<any> {

        const request: IDataRequest = {
            url: `/vendas/pedidos_pagamentos/historico/${pagamento_id}`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getComponentesByIds(ids: string): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/componentes?id_in=${ids}&includes=atributos,uploads,mppt,modulos_inversores`,
        }

        const response: IDataResponse = await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }
    async getNFHistorico(pedido_id: number, noLoading?: boolean): Promise<any> {

        const request: IDataRequest = {
            url: `/vendas/pedidos/notas_fiscais/historico/${pedido_id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getComponente(componente_id: number, noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/componentes/${componente_id}?includes=atributos,uploads,mppt`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getCategoria(id: number, noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/estoque/categorias_componentes/${id}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

    async getAtributos(noLoading?: boolean): Promise<any> {
        const request: IDataRequest = {
            url: `/cadastros/atributos`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }
        
        return [];
    }

    async getPedidosHistoricoErp(pedidoId: number, noLoading?: boolean): Promise<any> {

        const request: IDataRequest = {
            url: `/vendas/pedidos_historicos/carregar_historico_erp?pedido_id=${pedidoId}`,
        }

        const response: IDataResponse = noLoading ? await apiNoLoading.get(request) : await this.provider.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data;
        }

        return [];
    }

}


const adminStore: AdminStore = new AdminStore(api);

export default adminStore;
